import React from "react";
import { makeStyles, Theme, createStyles} from "@material-ui/core";

import {
    Typography,
    Button,
    Dialog,
    DialogContent,
    DialogActions,
} from "@material-ui/core";
import { DialogTitle } from "./DialogTitle";
const useStyle = makeStyles((theme: Theme) =>
    createStyles({
        dialogActionArea: {
            display: "block",
            paddingLeft: "20px",
            marginBottom: "20px"
        },
        dialogDeleteButton: {
            fontSize: "12px",
            fontWeight: 600,
            lineHeight: 1.83,
            letterSpacing: "normal",
            textAlign: "center",
            color: "#ffffff",
            // width: "89px",
            textTransform: "none",
            height: "36px",
            borderRadius: "4px",
            boxShadow: "1px 2px 2px 0 rgba(0, 0, 0, 0.24)",
            backgroundColor: "#5566d6",
            "&:hover": {
                backgroundColor: "#5566d6 !important"
            }
        },
        dialogCancelBtn: {
            boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.22)",
            backgroundColor: "#ffffff",
            border: "solid 1px #ececec",
            color: "#32325d",
            "&:hover": {
                backgroundColor: "#ffffff !important"
            }
        }
    })
)


export function ConfirmationDialog(props: any) {
    const { onCancel, open, onConfirm, msg, msg2, head, btnText } = props;
    const dailogClasses = useStyle();
    // const classes = useStyles();
    const handleCancel = () => {
        onCancel();
    };
    const handleOk = () => {
        onConfirm();
        onCancel();
    };

    const {
        dialogDeleteButton,
        dialogCancelBtn,
        dialogActionArea
    } = dailogClasses;
    return (
        <>
            <Dialog
                disableBackdropClick
                disableEscapeKeyDown
                onClose={() => onCancel()}
                // maxWidth="xs" commented because it was giving scroll bar in dailog box
                aria-labelledby="confirmation-dialog-title"
                open={open}
            >
                {head ? (
                    <DialogTitle
                        id="customized-dialog-title"
                        onClose={() => onCancel()}
                        style={{ paddingTop: "20px" }}
                    >
                        {head}
                    </DialogTitle>
                ) : null}
                <DialogContent>
                    <Typography
                        gutterBottom
                        style={{
                            padding: "24px 0px 30px 0px",
                            fontSize: "12px",
                            lineHeight: "1.8",
                            fontWeight: "normal"
                        }}
                    >
                        <span>{msg}</span>
                        <p>{msg2}</p>
                    </Typography>
                </DialogContent>
                <DialogActions className={dialogActionArea}>
                    <Button
                        variant="contained"
                        size="small"
                        data-testid="yes-button"
                        autoFocus
                        onClick={handleOk}
                        // color="primary"
                        className={dialogDeleteButton}
                    >
                        {!btnText ? "Yes" : btnText}
                    </Button>
                    <Button
                        variant="contained"
                        size="small"
                        data-testid="cancel-button"
                        autoFocus
                        onClick={handleCancel}
                        color="primary"
                        className={`${dialogCancelBtn} ${dialogDeleteButton}`}
                    >
                        Cancel
            </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}
// export default ConfirmationDialog;